import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageHeaderComponent } from './page-header.component';
import { PageHeaderService } from './page-header.service';

/**
 * Shared.
 */
import { GeolocationModule } from '@app/shared/geolocation/geolocation.module';
import { MainMenuModule } from '@app/shared/main-menu/main-menu.module';
import { AccountHeaderModule } from '@app/shared/account-header/account-header.module';

@NgModule({
  declarations: [
    PageHeaderComponent
  ],
  exports: [
    PageHeaderComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    GeolocationModule,
    MainMenuModule,
    AccountHeaderModule
  ],
  providers: [
    PageHeaderService
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})

export class PageHeaderModule {
  constructor() {
  }
}
